/**
 * Topbar Component
 * Global search, new transaction button, and sync status
 */

export class Topbar {
  constructor(container) {
    this.container = container;
    this.onSearch = null;
    this.onNewTransaction = null;
    this.searchDebounceTimeout = null;
  }

  render() {
    this.container.innerHTML = `
      <div class="topbar-left">
        <div class="global-search">
          <span class="global-search-icon">🔍</span>
          <input
            type="text"
            id="global-search-input"
            placeholder="Buscar lançamentos... (pressione / para focar)"
            autocomplete="off"
          />
        </div>
      </div>

      <div class="topbar-right">
        <div id="sync-status" class="sync-status idle">
          <span class="sync-icon">●</span>
          <span class="sync-text">Aguardando</span>
        </div>
        <button id="manual-sync-btn" class="btn btn-ghost btn-sm" title="Sincronizar agora">
          🔄
        </button>
        <button id="new-transaction-btn" class="btn btn-primary">
          ➕ Novo Lançamento
        </button>
      </div>
    `;

    this.attachEventListeners();
  }

  attachEventListeners() {
    // Global search
    const searchInput = this.container.querySelector('#global-search-input');
    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        this.handleSearch(e.target.value);
      });

      // Keyboard shortcut: / focuses search
      document.addEventListener('keydown', (e) => {
        if (e.key === '/' && !this.isTypingInInput(e.target)) {
          e.preventDefault();
          searchInput.focus();
        }

        // Esc clears search
        if (e.key === 'Escape' && e.target === searchInput) {
          searchInput.value = '';
          this.handleSearch('');
          searchInput.blur();
        }
      });
    }

    // New transaction button
    const newTransactionBtn = this.container.querySelector('#new-transaction-btn');
    if (newTransactionBtn) {
      newTransactionBtn.addEventListener('click', () => {
        if (this.onNewTransaction) {
          this.onNewTransaction();
        }
      });
    }

    // Manual sync button
    const manualSyncBtn = this.container.querySelector('#manual-sync-btn');
    if (manualSyncBtn) {
      manualSyncBtn.addEventListener('click', () => {
        if (window.CloudflareSync && window.CloudflareSync.manualSync) {
          window.CloudflareSync.manualSync();
        }
      });
    }

    // Keyboard shortcut: N opens new transaction
    document.addEventListener('keydown', (e) => {
      if ((e.key === 'n' || e.key === 'N') && !this.isTypingInInput(e.target)) {
        e.preventDefault();
        if (this.onNewTransaction) {
          this.onNewTransaction();
        }
      }
    });
  }

  handleSearch(query) {
    // Debounce search (300ms)
    clearTimeout(this.searchDebounceTimeout);
    this.searchDebounceTimeout = setTimeout(() => {
      if (this.onSearch) {
        this.onSearch(query.trim().toLowerCase());
      }
    }, 300);
  }

  isTypingInInput(element) {
    return (
      element.tagName === 'INPUT' ||
      element.tagName === 'TEXTAREA' ||
      element.isContentEditable
    );
  }

  updateSyncStatus(status, text) {
    const statusEl = this.container.querySelector('#sync-status');
    const iconEl = this.container.querySelector('.sync-icon');
    const textEl = this.container.querySelector('.sync-text');

    if (statusEl && iconEl && textEl) {
      // Remove all status classes
      statusEl.className = 'sync-status';

      // Add new status class
      statusEl.classList.add(status);

      // Update icon
      iconEl.className = 'sync-icon';
      if (status === 'syncing') {
        iconEl.classList.add('spinning');
      }

      // Update text
      textEl.textContent = text;
    }
  }

  setSearchCallback(callback) {
    this.onSearch = callback;
  }

  setNewTransactionCallback(callback) {
    this.onNewTransaction = callback;
  }
}
